import "./utilities_namespace.js";

// Utility for performing ajax requests and processing their responses in-order. Out-of-order responses are ignored. This
// is achieved by returning a promise object that is only resolved or rejected when an in-order response is received. As
// a result of this implementation, only callbacks chained onto the function call are affected by this processing.
// success/fail callbacks passed as arguments to the function call are not handled in this manner and will execute
// normally. The `progress` callback is called whenever any response is received, regardless of whether it was in-order
// or not. It receives a single argument, a boolean indicating whether the response was in-order. A `namespace` argument
// allows requests in different namespaces to execute out of order.

if (!Sparkle.Utilities.OrderedAJAX) {
  // Avoid duplicate load via dynamic loading
  Sparkle.Utilities.OrderedAJAX = {
    namespaces: {},

    getJSON(namespace, ...args) {
      return this.request("getJSON", namespace, ...Array.from(args));
    },

    get(namespace, ...args) {
      return this.request("get", namespace, ...Array.from(args));
    },

    post(namespace, ...args) {
      return this.request("post", namespace, ...Array.from(args));
    },

    ajax(namespace, ...args) {
      return this.request("ajax", namespace, ...Array.from(args));
    },

    // PRIVATE

    request(methodName, namespace, ...requestArgs) {
      const deferred = new jQuery.Deferred();
      const requestNumber = ++this.getNamespace(namespace).request;
      const process = this.processResponse.bind(this);
      jQuery[methodName](...Array.from(requestArgs || []))
        .done((...responseArgs) =>
          process(deferred, namespace, requestNumber, responseArgs, function () {
            return deferred.resolveWith(this, responseArgs);
          }),
        )
        .fail((...responseArgs) =>
          process(deferred, namespace, requestNumber, responseArgs, function () {
            return deferred.rejectWith(this, responseArgs);
          }),
        );

      return deferred.promise();
    },

    processResponse(deferred, namespace, requestNumber, responseArgs, fn) {
      if (this.isInOrder(namespace, requestNumber)) {
        this.getNamespace(namespace).response = requestNumber;
        deferred.notify(true, responseArgs);
        return fn();
      } else {
        return deferred.notify(false, responseArgs);
      }
    },

    isInOrder(namespace, requestIndex) {
      return this.getResponseNumber(namespace) < requestIndex;
    },

    getRequestNumber(namespace) {
      return this.getNamespace(namespace).request;
    },

    getResponseNumber(namespace) {
      return this.getNamespace(namespace).response;
    },

    getNamespace(namespace) {
      if (this.namespaces[namespace] == null) {
        this.namespaces[namespace] = { request: 0, response: 0 };
      }
      return this.namespaces[namespace];
    },
  };
}
